import { apiErrorActionCreator } from '../common/apiErrorAction';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const FETCH_USER_COMMUNITIES_REQUEST = 'FETCH_USER_COMMUNITIES_REQUEST';
export const FETCH_USER_COMMUNITIES_SUCCESS = 'FETCH_USER_COMMUNITIES_SUCCESS';
export const FETCH_USER_COMMUNITIES_FAILURE = 'FETCH_USER_COMMUNITIES_FAILURE';

export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';

export const fetchUserRequest = () => ({
  type: FETCH_USER_REQUEST
});

export const fetchUserCommunitiesRequest = ({ contentId }) => ({
  type: FETCH_USER_COMMUNITIES_REQUEST,
  payload: {
    contentId
  }
});

export const fetchUserSuccess = ({
  id,
  avatar_url: avatarUrl,
  big_avatar_url: bigAvatarUrl,
  default_locale: userLanguage
}) => {
  const user = {
    id,
    avatarUrl,
    bigAvatarUrl,
    userLanguage
  };

  return {
    type: FETCH_USER_SUCCESS,
    payload: {
      user
    }
  };
};

export const fetchUserCommunitiesSuccess = (communities) => {
  return {
    type: FETCH_USER_COMMUNITIES_SUCCESS,
    payload: {
      myCommunities: communities
    }
  };
};

export const fetchUserFailure = (response) =>
  apiErrorActionCreator(FETCH_USER_FAILURE)(response);

export const fetchUserCommunitiesFailure = (response) =>
  apiErrorActionCreator(FETCH_USER_COMMUNITIES_FAILURE)(response);

export const setUserLanguage = (language) => ({
  type: SET_USER_LANGUAGE,
  payload: {
    language
  }
});
